import React from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';

import * as firebase from '../firebase/firebase';
import * as routes from '../routes';
import * as firebasepkg from 'firebase';
import base64 from 'base-64';

const createUserCloudFuncURL =
  "https://us-central1-hoomiz-p0llux.cloudfunctions.net/admin/createUser";
const createUserCloudFuncURLTEST =
  "http://localhost:3000/hoomiz-p0llux/us-central1/admin/createUser/";

const withAuthorization = (condition) => (Component) => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      console.log('WITH Authorization props', this.props);
      firebase.auth.onAuthStateChanged(authUser => {
        if(authUser){
          authUser.getIdToken()
          .then((token) => {
            const payload = JSON.parse(base64.decode(token.split('.')[1]));
            if (!payload["admin"]) {
              console.error('User is not admin. ' + JSON.stringify(payload));
              this.props.history.push(routes.LOGIN);
            }
          })
        } else {
          this.props.history.push(routes.LOGIN);
        }
      });
    }

    render() {
      return this.props.sessionStore.authUser ? <Component {...this.props} /> : null;
    }
  }

  return compose(
    withRouter,
    inject('sessionStore'),
    observer
  )(WithAuthorization);
}

const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    componentDidMount() {
      const { sessionStore } = this.props;

      firebase.auth.onAuthStateChanged(authUser => {
        console.log('AuthUser', authUser);
        authUser
          ? sessionStore.setAuthUser(authUser)
          : sessionStore.setAuthUser(null);
      });
    }

    render() {
      return (
        <Component {...this.props} />
      );
    }
  }

  return inject('sessionStore')(WithAuthentication);
}

const generatePass = () => {
  var chars = "0123456789abcdefghijklmnopqrstuvwxyz-ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var pass = "";

  for (let i = 0; i < 32; i++) {
    pass += chars[Math.floor(Math.random() * chars.length)];
  }

  return pass;
}

const createUser = (data) => {
  return new Promise(function(resolve, reject) {
    console.log("EDF COUCOU")
    firebasepkg
      .auth()
      .currentUser.getToken()
      .then(function(token) {
        fetch(createUserCloudFuncURL,
          {
            method: "POST",
            mode: "cors",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token
            },
            body: JSON.stringify({
              email: data.email,
              password: data.password,
              data: data
            })
          }
        )
          .then(async res => {
            if (res.status == 200) {
              // AUTH User created successfully through cloud function, now create UserDATA
              const user = await res.json();
              console.log("then USer", user);
              resolve(user);
            } else {
              const error = await res.json();
              console.log("Error:", res.status, error);
              reject(error);
            }
          })
          .catch(e => {
            console.log("Error:", e);
            reject(e);
          });
      })
      .catch(e => {
        reject(e);
      });
    });
}

export {
  withAuthorization,
  withAuthentication,
  createUser
};



// WEBPACK FOOTER //
// ./src/utils/auth.js